import Axios from 'axios';

const API_URL_V3 = process.env.API_URL + "/api/v3/data/addresses/";

class Provinsi {
  index() {
    return Axios.get(API_URL_V3 + 'provinces?order_column=name&order_direction=asc');
  }

  show(province_id) {
    return Axios.get(API_URL_V3 + `provinces/${province_id}`);
  }
}

export default new Provinsi();



// WEBPACK FOOTER //
// ./src/api/daerahindonesia/provinsi.js